/**
 * Return font weight based on the size of the avatar
 * @param {string} size
 * @return {string} fontWeight
 */
export default function getFontWeight(size) {
  switch (size) {
    case 'sm':
      return 'semiBold';

    case 'md':
    case 'lg':
    default:
      return 'bold';
  }
}